import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgJunctionExit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="6 0 12 24" {...props}>
      <g fill="currentColor" transform="translate(6 4)">
        <path d="M7.503 4.343v6h-3v-6z" />
        <path d="M11.657 6L9.536 8.121 6 4.586 2.464 8.12.344 6 6 .343 11.657 6z" />
        <rect width={4} height={4} x={4} y={12} rx={2} />
      </g>
    </svg>
  );
}

export default tombacIcon('JunctionExit')(SvgJunctionExit);
